export const formatTime = (seconds) => {
    let minutesText = '';
    let secondsText = '';

    let minutes = 0;
    let lastSeconds = 0;

    if(seconds < 60) {
        lastSeconds = seconds
    } else {
        minutes = Math.floor(seconds/60);
        lastSeconds = seconds - minutes * 60;
    }

    if(minutes < 10) {
        minutesText = `0${minutes}`
    } else {
        minutesText = String(minutes)
    }

    if(lastSeconds < 10) {
        secondsText = `0${lastSeconds}`
    } else {
        secondsText = String(lastSeconds)
    }

    return `${minutesText}:${secondsText}`
}